var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKevlarhelm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "29px",
    height: "40px",
    viewBox: "0.624 0 29 40",
    enableBackground: "new 0.624 0 29 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.256,9.81c0.467,4.258,0.232,8.134-0.701,11.633l-1.486,4.111l-2.098,3.676l-2.102,2.534l-1.836,1.749l-1.4,0.875 l-0.525,0.438L14.846,35l-0.35-0.177c-3.031-2.097-5.424-4.664-7.172-7.695c-1.344-2.392-2.303-5.103-2.887-8.135L4,15.407v-2.887 l0.176-2.01l0.262-1.574l0.699,0.438c1.4,0.816,2.83,1.051,4.285,0.699l1.926-0.961l1.486-1.226l0.963-1.137l0.438-0.525L14.672,5 l0.523,1.049c1.693,2.563,3.615,3.936,5.775,4.111c1.049,0.057,2.156-0.204,3.322-0.788l0.438-0.438l0.35-0.175l0.176,0.697V9.81  M20.881,11.208c-2.332-0.057-4.404-1.312-6.209-3.759L14.496,7.71l-0.262,0.263L13.01,9.285l-1.662,1.137 c-1.926,1.165-3.936,1.282-6.037,0.348l-0.086,1.313L5.137,13.83l0.438,4.9c0.523,2.915,1.428,5.54,2.713,7.873 c1.572,2.856,3.76,5.218,6.559,7.085l0.875-0.614l1.313-1.049l1.486-1.488l1.486-2.011l2.1-3.499l1.398-3.849l0.789-7.258v-1.663 l-0.088-1.486L20.881,11.208 M21.582,13.396l0.086,4.548l-0.697,3.587l-1.051,2.887l-1.313,2.187l-1.4,1.662l-1.225,1.138 l-1.137,0.874l-2.975-2.537l-2.012-2.711l-1.225-2.712l-0.611-2.536l-0.262-2.45v-2.012v-1.312l0.176-0.614h0.086 c1.049,0.7,2.156,0.875,3.324,0.527l1.398-0.699l1.051-0.964l0.613-0.786l0.174-0.35h0.088c0.641,0.989,1.311,1.69,2.01,2.1 l1.926,0.786l1.66-0.087l1.139-0.527h0.176 M13.533,15.581l-2.1,0.615l-0.787,0.787l-0.699,1.136l-0.525,1.489l-0.174,0.26 l-0.264,0.263l-0.086,0.088h0.35l0.438-0.088h1.049l0.699-0.088l0.613,0.088l0.787,0.35l0.787,0.438l0.613,0.26l0.176,0.087 l0.262,0.177l0.436,0.088h2.975l0.785,0.174l0.789,0.178v-0.439c0-2.624-0.699-4.373-2.1-5.247c-0.584-0.469-1.225-0.7-1.926-0.7 L13.533,15.581"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_4_1_",
    x: 29.489,
    fill: "none",
    width: 39.39,
    height: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_3_1_",
    fill: "none",
    width: 29.489,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKevlarhelm);
export default __webpack_public_path__ + "static/media/kevlarhelm.23624dde22a55d4e841511c33d1f4f7c.svg";
export { ForwardRef as ReactComponent };